import React from 'react';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import './ChangeEmail.css';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
    },
});

class ChangeEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email: '', email2: '', email3: '', password: '', open: false, successChangeRequest: false};
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangeEmail2 = this.handleChangeEmail2.bind(this);
        this.handleChangeEmail3 = this.handleChangeEmail3.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChangeEmail(event) {
        this.setState({
            email: event.target.value
        });
    }

    handleChangeEmail2(event) {
        this.setState({
            email2: event.target.value
        });
    }

    handleChangeEmail3(event) {
        this.setState({
            email3: event.target.value
        });
    }

    handleChangePassword(event) {
        this.setState({
            password: event.target.value
        });
    }

    handleSubmit(event) {
        event.persist();
        console.log(this.state.email);
        fetch("/account-management/api/request-email-change", {
            method: 'post',
            body: JSON.stringify({email: this.state.email, email_new: this.state.email2, password: this.state.password}),
            headers: {'Content-Type': 'application/json'}
        })
            .then(
                (response) => {
                    let successChangeRequest  = false;
                    if(200 === response.status) {
                        successChangeRequest = true;
                        console.log('User is found');
                    } else if(404 === response.status) {
                        console.log('User is not found');
                    } else {
                        console.log('Unknown API response');
                    }

                    this.setState({
                        open: true,
                        successChangeRequest
                    });
                },
                (error) => {
                    console.error(`Failed to create reset token`, error);
                }
            )
    }

    componentDidMount() {
        ValidatorForm.addValidationRule('isEmailMatch', (value) => {
            if (value !== this.state.email2) {
                return false;
            }
            return true;
        });
    }

    render() {
        const { classes } = this.props;

        return <ValidatorForm autoComplete="off" className={'reset-password-form'} onSubmit={this.handleSubmit}>
            <h3 className={'reset-password-label'}>Change email</h3>
            <TextValidator
                id="email"
                label="Email"
                value={this.state.email}
                margin="normal"
                required={true}
                fullWidth={true}
                onChange={this.handleChangeEmail}
                validators={['required', 'isEmail']}
                errorMessages={['this field is required', 'email is not valid']}
            />
            <TextValidator
                id="password1"
                label="Password"
                value={this.state.password}
                type="password"
                margin="normal"
                required={true}
                fullWidth={true}
                onChange={this.handleChangePassword}
                validators={['required']}
                errorMessages={['this field is required']}
            />
            <TextValidator
                id="email2"
                label="New Email"
                value={this.state.email2}
                margin="normal"
                required={true}
                fullWidth={true}
                onChange={this.handleChangeEmail2}
                validators={['required', 'isEmail']}
                errorMessages={['this field is required', 'email is not valid']}
            />
            <TextValidator
                id="email3"
                label="Confirm New Email"
                value={this.state.email3}
                margin="normal"
                required={true}
                fullWidth={true}
                onChange={this.handleChangeEmail3}
                validators={['required', 'isEmail', 'isEmailMatch']}
                errorMessages={['this field is required', 'email is not valid', 'new email addresses not match']}
            />
            <Button variant="outlined" className={'reset-password-button'} type="submit">
                Save
            </Button>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.state.open}
            >
                <div style={getModalStyle()} className={classes.paper}>
                    {this.state.successChangeRequest && (
                        <Typography variant="subtitle1" id="simple-modal-description">
                          An email with detail instructions is sent to the new email address: <b>{this.state.email2}</b>.
                        </Typography>
                    )}
                    {!this.state.successChangeRequest && (
                        <div>
                            <Typography variant="subtitle1" id="simple-modal-description">
                                Can't find user using specified credentials.
                            </Typography>
                            <Button variant="outlined" className={'reset-password-button'} onClick={() => { this.setState({open: false}) }}>
                                CLOSE
                            </Button>
                        </div>
                    )}
                </div>
            </Modal>

        </ValidatorForm>;
    }
}

ChangeEmail.propTypes = {
    classes: PropTypes.object.isRequired,
};

const ChangeEmailWrapped = withStyles(styles)(ChangeEmail);

export default ChangeEmailWrapped;
